module.exports = __webpack_public_path__ + "static/leaves-f20fb10daa8c5d033cd248e7c81fa43e.jpg";